export default {
  title: 'GEOFENCE UNIVERSAL SETTINGS',
  items: {
    RadiusDistance: {
      label: 'Radius Distance',
      type: 'integer',
      unit: 'miles'
    },
    GeofenceExit: {
      label: 'Confirm Geofence Exit',
      type: 'integer',
      unit: 'no. of times'
    },
    FrequencyCheckAroundRadius: {
      label: 'Interval of checking drivers around radius',
      type: 'integer',
      unit: 'seconds'
    },
    FrequencyCheckWithinRadius: {
      label: 'Interval of checking drivers within radius',
      type: 'integer',
      unit: 'seconds'
    },
    FrequencyCheckWithinGeofence: {
      label: 'Interval of checking drivers within geofence',
      type: 'integer',
      unit: 'seconds'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/geofence-universal-settings.js